import 'reflect-metadata';
import './i18n';
import './styles/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { AmplitudeProvider } from './amplitude/amplitudeContext';
import reportWebVitals from './reportWebVitals';
import Agents from './views/Agents';
import AgentProfile from './views/AgentProfile';
import { ApolloProvider } from './components/Apollo';
import { ScrollToTop } from './components/ScrollToTop';
import { DevModeProvider } from './components/DevMode';

ReactDOM.render(
  <React.StrictMode>
    <DevModeProvider>
      <AmplitudeProvider>
        <ApolloProvider>
          <Router>
            <ScrollToTop />
            <Switch>
              <Route path="/" exact>
                <Agents />
              </Route>
              <Route path="/agent/:nameId" exact>
                <AgentProfile />
              </Route>
              <Route path="/brokers" exact>
                <Agents brokers />
              </Route>
            </Switch>
          </Router>
        </ApolloProvider>
      </AmplitudeProvider>
    </DevModeProvider>
  </React.StrictMode>,
  document.getElementById('sidx-agent-directory')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
